module.exports = __webpack_public_path__ + "img/verification_hubbel_v01.4cc68749.svg";